import {
  IInvoiceData,
  IPaymentPlanData,
  IPaymentPlanScheduleData
} from '@/models';
import {
  IFetchPaymentPlansParams,
  IPaymentPlanService,
  ICreatePaymentPlanScheduleInvoiceData
} from './payment-plan.types';
import { AxiosInstance } from 'axios';
import { axios } from '@/plugins/axios';
import { IPaginatedListData } from '../types';

export class PaymentPlanService implements IPaymentPlanService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/invoices/';
  }

  fetchPaymentPlans(
    params: IFetchPaymentPlansParams
  ): Promise<IPaginatedListData<IPaymentPlanData>> {
    return this.axios
      .get<IPaginatedListData<IPaymentPlanData>>(
        `${this.endpoint}payment-plans/`,
        {
          params
        }
      )
      .then(({ data }) => data);
  }

  fetchPaymentPlan(id: number): Promise<IPaymentPlanData> {
    return this.axios
      .get<IPaymentPlanData>(`${this.endpoint}payment-plans/${id}/`)
      .then(({ data }) => data);
  }

  createPaymentPlan(data: IPaymentPlanData): Promise<IPaymentPlanData> {
    return this.axios
      .post<IPaymentPlanData>(`${this.endpoint}payment-plans/`, data)
      .then(({ data }) => data);
  }

  updatePaymentPlan(data: IPaymentPlanData): Promise<IPaymentPlanData> {
    return this.axios
      .patch<IPaymentPlanData>(
        `${this.endpoint}payment-plans/${data.id}/`,
        data
      )
      .then(({ data }) => data);
  }

  deletePaymentPlan(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}payment-plans/${id}/`);
  }

  cancelPaymentPlan(id: number): Promise<IPaymentPlanData> {
    return this.axios
      .put<IPaymentPlanData>(
        `${this.endpoint}payment-plans/${id}/cancel_payment_plan/`
      )
      .then(({ data }) => data);
  }

  //Schedule
  fetchPaymentPlanSchedules(
    paymentPlanId: number
  ): Promise<IPaymentPlanScheduleData[]> {
    return this.axios
      .get<IPaymentPlanScheduleData[]>(
        `${this.endpoint}payment-plans/${paymentPlanId}/schedules/`
      )
      .then(({ data }) => data);
  }

  fetchPaymentPlanSchedule(
    paymentPlanId: number,
    id: number
  ): Promise<IPaymentPlanScheduleData> {
    return this.axios
      .get<IPaymentPlanScheduleData>(
        `${this.endpoint}payment-plans/${paymentPlanId}/schedules/${id}/`
      )
      .then(({ data }) => data);
  }

  createPaymentPlanSchedule(
    paymentPlanId: number,
    data: IPaymentPlanScheduleData
  ): Promise<IPaymentPlanScheduleData> {
    return this.axios
      .post<IPaymentPlanScheduleData>(
        `${this.endpoint}payment-plans/${paymentPlanId}/schedules/`,
        data
      )
      .then(({ data }) => data);
  }

  updatePaymentPlanSchedule(
    paymentPlanId: number,
    data: IPaymentPlanScheduleData
  ): Promise<IPaymentPlanScheduleData> {
    return this.axios
      .patch<IPaymentPlanScheduleData>(
        `${this.endpoint}payment-plans/${paymentPlanId}/schedules/${data.id}/`,
        data
      )
      .then(({ data }) => data);
  }

  deletePaymentPlanSchedule(paymentPlanId: number, id: number): Promise<any> {
    return this.axios.delete(
      `${this.endpoint}payment-plans/${paymentPlanId}/schedules/${id}/`
    );
  }

  createPaymentPlanScheduleInvoice(
    paymentPlanId: number,
    scheduleId: number,
    data: ICreatePaymentPlanScheduleInvoiceData
  ): Promise<IInvoiceData> {
    return this.axios
      .post<IInvoiceData>(
        `${this.endpoint}payment-plans/${paymentPlanId}/schedules/${scheduleId}/create_invoice/`,
        data
      )
      .then(({ data }) => data);
  }
}

const invoiceService = new PaymentPlanService(axios);
export default invoiceService;
